// Rain on Cotton Paper — defaults + tested combos. Default text and
// combo values come straight from the curator-tuned spec; do not change
// without product approval.

export const FONT_LIST = [
  'Cormorant Garamond',
  'Playfair Display',
  'EB Garamond',
  'Lora',
  'Crimson Text',
  'Italiana',
  'Antic Didone',
];

export const defaults = {
  // Content
  openingText: "Before the day begins,\nwe wanted to share\nthis moment with you.",
  finalText: 'From yes to welcome',

  // Background
  backgroundMode: 'paper', // 'paper' | 'image'
  backgroundColor: '#ebe7df',
  backgroundImageUrl: null,
  // Phase 1.9.9 — Background opacity. Applied ONLY to the paper-bg
  // layer (and its texture pseudo-elements), so the underlying
  // invitation hero can subtly show through during playback. Text,
  // ripples, and water-lens layers stay at full opacity for readability.
  backgroundOpacity: 0.94,
  // Phase 1.9.12 — Backdrop blur. Blurs whatever sits BEHIND the paper
  // layer (i.e. the invitation hero). Doesn't touch opener text,
  // ripples, lens, final text, or the uploaded background image itself.
  // 0 = none (default cotton-paper look); 8px = strongest editorial.
  backdropBlur: 0,

  // Phase 1.9.13 — Water ripples are now OPT-IN. Default premium look:
  // cotton paper → text assembles → holds → drifts away → invitation.
  // When disabled, the preset skips all rain DOM, intervals, ripples,
  // water lens, and SVG distortion filter entirely.
  waterRipplesEnabled: false,

  // Rain (only takes effect when waterRipplesEnabled is true)
  rainDensity: 1,            // drops-per-second multiplier (baseline 1.3/s)
  rippleDurationScale: 1,    // 1 = original; <1 faster, >1 slower

  // Text effect — distortion is part of the water-ripple system and is
  // ignored when ripples are off. We keep the saved value so toggling
  // ripples back on restores the previous configuration.
  distortionStrength: 0,
  holdTime: 4200,            // ms text remains revealed (a.k.a. hold-after-reveal)
  // Phase 1.9.14 — reveal/fly per-character cadence. Tuned for a soft
  // editorial feel rather than a particle effect. textRevealDelay is
  // derived from waterRipplesEnabled at runtime (1200ms quiet / 4600ms
  // when ripples carry the intro) so we don't store both.
  revealSpeed: 40,           // ms between letters revealing
  flySpeed: 20,              // ms between letters flying away
  flyDirection: 'up',        // see schema for allowed values

  // Phase 1.9.15 — per-stage timing controls.
  //  flyDuration       — CSS transition duration of each character's fly-away.
  //  finalFadeDuration — final-text opacity fade-in duration.
  //  finalHoldTime     — how long final text holds (after fade completes)
  //                      before the opener-to-invitation transition begins.
  flyDuration: 2400,
  finalFadeDuration: 2200,
  finalHoldTime: 2200,

  // Typography
  openingTypography: {
    fontFamily: 'Cormorant Garamond',
    color: '#3b342c',
    sizeScale: 1,
  },
  finalTypography: {
    fontFamily: 'Cormorant Garamond',
    color: '#3b342c',
    sizeScale: 1,
  },
};

export const combos = [
  {
    id: 'original',
    label: 'Original',
    // Phase 1.9.13 — Original recreates the full water-ripple experience.
    settings: { waterRipplesEnabled: true, rainDensity: 1, rippleDurationScale: 1, distortionStrength: 4, holdTime: 4200 },
  },
  {
    id: 'quiet',
    label: 'Quiet',
    settings: { waterRipplesEnabled: false, distortionStrength: 0, holdTime: 5200 },
  },
  {
    id: 'alive',
    label: 'Alive',
    settings: { waterRipplesEnabled: true, rainDensity: 1.2, rippleDurationScale: 0.95, distortionStrength: 4, holdTime: 4200 },
  },
  {
    id: 'expressive',
    label: 'Expressive',
    settings: { waterRipplesEnabled: true, rainDensity: 1.35, rippleDurationScale: 0.9, distortionStrength: 6, holdTime: 3600 },
  },
];
